module.exports = __webpack_public_path__ + "img/banner.7e3a5c84.png";